import { countrySlice } from "./countrySlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = countrySlice;
const moduleUrl = '/api/pricing/pricingConditions/country'

export const setValidationErrors = actions.setValidationErrors;

export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);